<template>
  <HgModal v-model="isModalVisible" :containerCssClass="$style.container" @close="closeModal">
    <img :src="authModalSvg" :class="$style.authModalSvg" :alt="''" />

    <section :class="$style.title">
      <h2>{{ t('valuationFormModal.title') }}</h2>
    </section>
    <section :class="$style.content">
      {{ t('valuationFormModal.body') }}
    </section>

    <HgButton :class="$style.signInNowButton" theme="secondary" @click="handleConfirm">
      {{ t('valuationFormModal.cta') }}
    </HgButton>
  </HgModal>
</template>

<script setup lang="ts">
import { getCurrentPlatform } from '@/helpers/Platform/Platform';
import { HgButton, HgModal } from '@smg-real-estate/domus';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

interface Props {
  showModal: boolean;
}

const props = defineProps<Props>();

interface Emits {
  onClose: [];
  onConfirm: [];
}

const emit = defineEmits<Emits>();

const { t } = useI18n();

// Reactive data
const platform = ref(getCurrentPlatform());
const authModalSvg = ref('');

// Computed properties
const isModalVisible = computed({
  get(): boolean {
    return props.showModal;
  },
  set(value: boolean) {
    return value;
  },
});

// Methods
const closeModal = () => {
  emit('onClose');
};

const handleConfirm = () => {
  emit('onConfirm');
};

// Lifecycle
onMounted(async () => {
  authModalSvg.value = (
    await import(
      `@/assets/images/landing-illustration-transactions${platform.value === 'hg' ? '-hg' : ''}.svg?url`
    )
  ).default;
});
</script>

<style lang="scss" module>
@use '@/assets/variables' as *;

.container {
  flex: unset;
  margin-right: $space-150;
  margin-left: $space-150;
  width: fit-content;
  max-width: min-content !important;

  @include grid-media-query(sm) {
    margin-right: 0;
    margin-left: 0;
  }

  .authModalSvg {
    margin: 0 auto 1rem auto;
    display: block;
    width: 11em;
    height: 11em;
  }

  .title {
    display: block;
    width: fit-content;
    font-weight: 800;
    white-space: nowrap;

    h2 {
      margin: 0 0 0.8rem 0;
    }
  }
  @media (max-width: 768px) {
    .title {
      white-space: normal;
    }
  }
  .content {
    max-width: fit-content;
    padding: 0 0 $space-200 0;
  }

  .signInNowButton {
    width: 100%;
  }
}
@media (max-width: 768px) {
  .container {
    max-width: none !important;
  }
}
</style>
